module.exports = __webpack_public_path__ + "img/warning.8fce17b2.svg";